import React, { useEffect, useRef, useState } from 'react';
import { Modal, Stack } from 'react-bootstrap';
import { Button, Icon } from 'lb-components';
import {
  BalanceIcon,
  PlusIcon,
  MinusIcon,
  BackspaceIcon,
} from '../../../../assets/icons';
import { useTranslation } from 'lb-store';

import classes from './GameDepositModal.module.scss';
import { UseUser } from 'lb-store/src/hooks';

const GameDepositModal = ({ onSuccess, onCancel, balance, ...props }) => {
  const inputRef = useRef();
  const User = UseUser()
  const [amount, setAmount] = useState(User?.User?.balance?.balance || 0);
  const [lastAction, setLastAction] = useState();
  //const [showInput, setShowInput] = useState(false);
  const { t } = useTranslation();

  const hotMoney = (m) => {
    if (m > 100000) m = 100000;

    if (m < 10) return [2, 5, 10];

    const r = Math.pow(10, parseInt(m).toString().length - 1);
    const n = Math.trunc(m / r) * r;
    const arr = [0.2, 0.5, 1];
    const res = [];

    for (let el of arr) {
      let amount = Math.round(el * n);
      res.push(amount);
    }
    return res;
  };

  const callback = (error) => {
    console.log(error);
  };
  const quickActionHandler = (input) => {
    //setShowInput(false);

    setAmount((prevState) => {
      let amount = parseFloat(prevState) || 0;
      let newVal;
      //handle +-1
      if (Math.abs(input) === 1) {
        newVal = amount + input;
        setLastAction(null);
      } else if (lastAction === input) {
        newVal = amount + input;
      } else {
        newVal = input;
        setLastAction(input);
      }

      newVal = newVal < 0 ? 0 : newVal;
      newVal = newVal > balance ? balance : newVal;

      return newVal.toFixed(2);
    });
  };

  const limitHandler = (amount) => {
    const parsed = parseFloat(amount) || 0;
    if (parsed < 0) setAmount('0');
    else if (parsed > balance) setAmount(balance.toString());
    else if (amount.split('.')[1]?.length > 2) setAmount(parsed.toFixed(2));
    else setAmount(amount);

    setLastAction(null);
  };

  /*useEffect(() => {
    if (showInput) {
      inputRef.current.focus();
    }
  }, [showInput]);*/

  const intervalRef = useRef();
  const firstClick = useRef(false);
  return (
    <Modal
      show
      centered
      contentClassName={classes.modal}
      dialogClassName={classes.wrapper}
      onHide={onCancel}
      {...props}
    >
      <Modal.Header
        className={classes.header}
        closeButton
        closeVariant={'white'}
      >
        <h1>{t('ანგარიშის შევსება')}</h1>
      </Modal.Header>
      <Modal.Body className={classes.body}>
        <div className={classes.balanceContainer}>
          <label>{t('ძირითადი ანგარიში')}</label>
          <span>{balance}₾</span>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            marginTop: '1.5rem',
            flexWrap: 'wrap',
            rowGap: '1.5rem',
            columnGap: '1rem',
          }}
        >
          <div className={classes.quickActions}>
            {hotMoney(balance).map((val) => (
              <Button
                key={val}
                variant={'secondary'}
                onClick={() => quickActionHandler(val)}
                data-current={lastAction === val ? '+' : ''}
              >
                {val}₾
              </Button>
            ))}
            <Button
              variant={'secondary'}
              onClick={() => {
                setAmount(balance.toString());
                setLastAction(null);
              }}
            >
              ALL
            </Button>
          </div>
          <div className={classes.amountContainer}>
            <Button
              variant={'secondary'}
              onPointerDown={(e) => {
                quickActionHandler(-1);
                intervalRef.current = setInterval(() => {
                  quickActionHandler(-1);
                }, 300);
              }}
              onPointerUp={(e) => {
                clearInterval(intervalRef.current);
              }}
              onPointerOut={(e) => {
                clearInterval(intervalRef.current);
              }}
            >
              <Icon Icon={MinusIcon} type={'vec'} />
            </Button>
            <input
              ref={inputRef}
              /*value={parseFloat(amount) ? parseFloat(amount) : ''}
              type={'number'}*/
              value={amount}
              type={'text'}
              onChange={(e) => limitHandler(e.target.value)}
              style={{
                flex: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                fontFamily: ' lbet-st',
                fontSize: '2.6rem',
                lineHeight: '2.6rem',
                width: '100%',
                minWidth: '18rem',
                border: 0,
                outline: 0,
                textAlign: 'center',
                margin: 0,
                padding: 0,
              }}
              onFocus={(e) => e.target.select()}
            />
            <Button
              variant={'secondary'}
              onPointerDown={(e) => {
                quickActionHandler(1);
                intervalRef.current = setInterval(() => {
                  quickActionHandler(1);
                }, 300);
              }}
              onPointerUp={(e) => {
                clearInterval(intervalRef.current);
              }}
              onPointerOut={(e) => {
                clearInterval(intervalRef.current);
              }}
            >
              <Icon Icon={PlusIcon} type={'vec'} />
            </Button>
          </div>
        </div>

        <input
          type={'range'}
          min={0.0}
          max={balance}
          step={0.01}
          value={parseFloat(amount) || 0}
          onChange={(e) => {
            setLastAction(null);
            setAmount((parseFloat(e.target.value) || 0).toFixed(2));
          }}
          style={{
            margin: '2.4rem 0',
            backgroundSize: `${((parseFloat(amount) || 0) * 100) / balance}% 100%`,
          }}
        />
        <Button
          variant={'success'}
          style={{
            padding: '1.5rem 1rem',
            fontSize: '2.1rem',
            marginBottom: '1.2rem',
            fontFamily: 'lbet-st',
          }}
          onClick={() =>
            {
                if (firstClick.current) return;
                firstClick.current = true;
                setTimeout(() => {
                    firstClick.current = false;
                }, 1000);
                onSuccess({
                    amount: parseFloat(amount) || 0,
                    callback: callback,
                    onCancel: onCancel,
                })
            }
          }
        >
          {t('თანხის გადარიცხვა')}
        </Button>
        <Button
          variant={'secondary-outline'}
          style={{
            padding: '1.5rem 1rem',
            fontSize: '2.1rem',
            marginBottom: '1rem',
            fontFamily: 'lbet-st',
            color: 'var(--bs-blue-gray)',
          }}
          onClick={onCancel}
        >
          {t('გაუქმება')}
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default GameDepositModal;
